'use strict';

module.exports = /[^\d.-]/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/var/NON_DECIMAL_REG.js
// module id = 843
// module chunks = 0